import { Response } from 'src/types';

import { apiRequest } from '../api';
import { endpoints } from '../config';
import { RequestMethodEnum } from '../types';
import { createFormData } from 'src/helpers/formData';
import { AddThemeRequest, Theme } from './types';

export const getThemes = async (): Promise<Theme[]> => {
  const response = await apiRequest<Response<Theme[]>, void>(
    endpoints.themes.getAll,
    RequestMethodEnum.GET,
    {}
  );
  return response?.data || [];
};

export const getTheme = async (id: number): Promise<Theme | undefined> => {
  const response = await apiRequest<Response<Theme>, void>(
    endpoints.themes.getDetails(id),
    RequestMethodEnum.GET,
    {}
  );
  return response?.data;
};

export const addTheme = async (
  data: AddThemeRequest
): Promise<Theme | undefined> => {
  const formData = createFormData(data);

  const response = await apiRequest<Response<Theme>, FormData>(
    endpoints.themes.add,
    RequestMethodEnum.POST,
    {
      formData,
      showErrorMessage: true,
      showSuccessMessage: true,
    }
  );
  return response?.data;
};

export const deleteTheme = async (
  id: number
): Promise<{ id: number } | undefined> => {
  const response = await apiRequest<Response<{ id: number }>, void>(
    endpoints.themes.delete(id),
    RequestMethodEnum.DELETE,
    {
      showErrorMessage: true,
      showSuccessMessage: true,
    }
  );
  return response?.data;
};
